import { createHashHistory as createHistory } from "history";

const history = createHistory();

export default history;
